WiseMetering.Views.EditUtility = WiseMetering.Views.Modal.Save.extend({
    template: 'templates/utilities/edit',
    title: () => i18next.t('modal.title.utilities.edit'),
    form_prefix: 'utility',
    className: 'mbx-info text-left',
    ui: {
        extra: '#utility-extra',
        indicator: '#utility-indicator'
    },

    onShow: function() {
        const
            utilityKind = this.model.utilityKind(),
            indicators = WiseMetering.indicators.where({ site_id: this.model.get('site_id'), kind_slug: utilityKind.indicatorKindSlug() });

        this.ui.indicator.html(WiseMetering.utils.optionsFromModels(indicators, 'name', this.model.get('indicator_id'), false));

        if (utilityKind.get('slug') === 'electricity') {
            this.addCapacitive();
            this.addInductive();
        }
    },

    addCapacitive: function() {
        const template = `
            <dt>
                <label for='utility-capacitive-energy'>${i18next.t('indicatorKinds.capacitive_energy')}</label>
            </dt>
            <dd>
                <select class='text' id='utility-capacitive-energy' name='utility[capacitive_energy_id]'></select>
            </dd>
        `;

        this.ui.extra.append(template);

        const capacitiveIndicators = WiseMetering.indicators.where({ site_id: this.model.get('site_id'), kind_slug: 'capacitive_energy' });
        this.$('#utility-capacitive-energy').html(WiseMetering.utils.optionsFromModels(capacitiveIndicators, 'name', this.model.get('capacitive_energy_id'), true));
    },

    addInductive: function() {
        const template = `
            <dt>
                <label for='utility-inductive-energy'>${i18next.t('indicatorKinds.inductive_energy')}</label>
            </dt>
            <dd>
                <select class='text' id='utility-inductive-energy' name='utility[inductive_energy_id]'></select>
            </dd>
        `;

        this.ui.extra.append(template);

        const inductiveIndicators = WiseMetering.indicators.where({ site_id: this.model.get('site_id'), kind_slug: 'inductive_energy' });
        this.$('#utility-inductive-energy').html(WiseMetering.utils.optionsFromModels(inductiveIndicators, 'name', this.model.get('inductive_energy_id'), true));
    }
});
